<template>
  <div class="noticeBox">
    <Swipe
        v-if="notices"
        vertical
        class="notice"
        :show-indicators="false"
        :touchable="false"
        :autoplay="0"
        indicator-color="white"
    >
      <Swipe-item v-for="(item, index) in notices" :key="index">
        <img class="notice_img" src="@/assets/home/notice.png" alt=""/>
        榮耀貸:
        {{ l.home_successfulLoanToday.replace("XX", item.num) }}
      </Swipe-item>
    </Swipe>
  </div>
</template>

<script>
import l from "@/locales";
import {Swipe, SwipeItem} from "vant";
import moment from "moment";

export default {
  name: "notice",
  data() {
    return {
      l: {
        ...l.home,
        ...l.repayMethods,
        ...l.orderItem,
        ...l.other,
        ...l.tabbar,
      },
      notices: [],
    };
  },
  components: {
    Swipe,
    SwipeItem,
  },
  created() {
    this.initNotices();
  },
  methods: {
    initNotices() {
      let timer = JSON.parse(localStorage.getItem("timer") || "{}");
      let day = moment().date();
      let random = Math.floor(Math.random() * 100);
      let randomNumber;
      if (Object.keys(timer).length > 0) {
        if (timer["time" + day]) {
          randomNumber = timer["time" + day] + moment().hours() * 100 + Math.floor(moment().minutes() * 7);
        } else {
          timer["time" + day] = random;
          randomNumber = random + moment().hours() * 100 + Math.floor(moment().minutes() * 7);
        }
        localStorage.setItem("timer", JSON.stringify(timer));
      } else {
        randomNumber = random + moment().hours() * 100 + Math.floor(moment().minutes() * 7);
        let obj = {};
        obj["time" + day] = random;
        localStorage.setItem("timer", JSON.stringify(obj));
      }
      this.notices.push({
        num: randomNumber
      });
    },
    // initNotices() {
    //   // const phoneNumss = ["3", "7", "8", "9"];
    //   const phoneNumss = ["9"];
    //   // 获取1-10之间的随机数
    //   while (this.notices.length < 100) {
    //     let amount = Math.floor(Math.random() * 285) + 15;
    //     let num = Math.floor(Math.random() * 99999999) + 10000000;
    //     let phoneNum = 0;
    //     let phone = phoneNumss[phoneNum] + num;
    //     amount = amount * 100;
    //     phone = "0" + phone.replace(/(\d{3})\d+(\d{3})/, "$1***$2");

    //     let amount2 = Math.floor(Math.random() * 200) + 300;
    //     let num2 = Math.floor(Math.random() * 99999999) + 10000000;
    //     let phoneNum2 = 0;
    //     let phone2 = phoneNumss[phoneNum2] + num2;
    //     amount2 = amount2 * 100;
    //     phone2 = "0" + phone2.replace(/(\d{3})\d+(\d{3})/, "$1***$2");
    //     const arr = [
    //       {
    //         amount,
    //         phone,
    //       },
    //       {
    //         amount: amount2,
    //         phone: phone2,
    //       },
    //     ];
    //     this.notices.push(...arr);
    //   }
    // },
  },
};
</script>

<style lang="less" scoped>
.noticeBox {
  padding: 0 15px;

  .notice {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
    margin-bottom: 10px;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 13px;
    color: #28435B;

    background: linear-gradient(180deg, #D9F8FC 0%, #FFFFFF 100%);
    border-radius: 10px;
    border: 1px solid #85C6CE;

    .notice_img {
      width: 20px;
      height: 20px;
      margin-left: 20px;
      margin-right: 10px;
    }

    /deep/ .van-swipe__track--vertical {
      height: 48px !important;
    }

    .van-swipe-item {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
}
</style>
